import React from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'

export default function AddIcon(props) {
    const { style, color } = props;
    const classes = useStyles({color, ...props})()

    return(
        <svg className={classes.container}  style={style} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.194 0.5C16.254 0.5 18 2.228 18 5.297V13.703C18 16.754 16.263 18.5 13.203 18.5H4.797C1.728 18.5 0 16.754 0 13.703V5.297C0 2.228 1.728 0.5 4.797 0.5H13.194ZM8.991 5.459C8.577 5.459 8.244 5.792 8.244 6.206V8.744H5.697C5.499 8.744 5.31 8.825 5.166 8.96C5.031 9.104 4.95 9.2921 4.95 9.491C4.95 9.905 5.283 10.238 5.697 10.247H8.244V12.794C8.244 13.208 8.577 13.541 8.991 13.541C9.405 13.541 9.738 13.208 9.738 12.794V10.247H12.294C12.708 10.238 13.041 9.905 13.041 9.491C13.041 9.077 12.708 8.744 12.294 8.744H9.738V6.206C9.738 5.792 9.405 5.459 8.991 5.459Z" fill="white"/>
        </svg>
        
    )
}


const useStyles = ({color, ...props}) => makeStyles((theme) => ({
    container:{
        '& path': {
            fill: color ? color : "#FFF",
            width: props.width,
         },
    }
}));